export const n = (value) =>
  Number(
    String(value ?? 0)
      .replaceAll(" ", "")
      .replace(",", "."),
  ) || 0;
export const round = (value) =>
  Math.round((value + Number.EPSILON) * 100) / 100;
export const isCorrectionStage = (stage) =>
  ["корректировка", "корректировки"].includes(
    String(stage?.type || "")
      .trim()
      .toLowerCase(),
  );
export const employeeAmount = (d, e) =>
  !e.enabled
    ? 0
    : e.leading === "amount"
      ? n(e.amount)
      : round((n(d.amount) * n(e.percentage)) / 100);
export const employeePercentage = (d, e) =>
  !e.enabled
    ? 0
    : e.leading === "amount"
      ? n(d.amount) > 0
        ? (n(e.amount) / n(d.amount)) * 100
        : 0
      : n(e.percentage);
export function changeEmployee(d, index, field, value) {
  return {
    ...d,
    employees: d.employees.map((e, i) =>
      i !== index
        ? e
        : {
            ...e,
            [field]: value,
            leading: field,
            ...(field === "amount"
              ? { percentage: n(d.amount) ? (n(value) / n(d.amount)) * 100 : 0 }
              : { amount: round((n(d.amount) * n(value)) / 100) }),
          },
    ),
  };
}
export function changeSubTeam(d, team, sub, amount) {
  const members = d.employees.filter(
    (e) => e.enabled && e.team === team && (e.sub_team || "") === sub,
  );
  const total = members.reduce((s, e) => s + employeePercentage(d, e), 0);
  return {
    ...d,
    employees: d.employees.map((e) =>
      members.includes(e)
        ? {
            ...e,
            leading: "percentage",
            percentage: n(d.amount)
              ? (n(amount) / n(d.amount)) *
                100 *
                (total ? employeePercentage(d, e) / total : 1 / members.length)
              : 0,
          }
        : e,
    ),
  };
}
export function previewCorrection(departments, services, vatPercent) {
  const production = round(departments.reduce((s, d) => s + n(d.amount), 0));
  const productionPercent =
    100 - services.reduce((s, r) => s + n(r.base_percentage), 0);
  const total =
    productionPercent > 0 ? round((production * 100) / productionPercent) : 0;
  const tax = services.find((r) => r.category === "tax" && !r.removed);
  const vat = tax ? n(vatPercent) : 0,
    gross = round(total * (1 + vat / 100)),
    vatAmount = round(gross - total);
  const rows = services.map((r) => {
    const extra = r === tax ? vatAmount : 0;
    const amount = r.removed
      ? 0
      : r.leading === "amount"
        ? n(r.amount)
        : round((total * n(r.percentage)) / 100) + extra;
    const base = r.removed ? 0 : amount - extra;
    return {
      ...r,
      calculatedAmount: round(amount),
      calculatedPercentage:
        r.leading === "amount"
          ? total
            ? (base / total) * 100
            : 0
          : n(r.percentage),
      base,
    };
  });
  const difference = round(
    total - production - rows.reduce((s, r) => s + r.base, 0),
  );
  const departmentErrors = departments.filter(
    (d) =>
      n(d.amount) <= 0 ||
      Math.abs(
        d.employees.reduce((s, e) => s + employeePercentage(d, e), 0) - 100,
      ) >= 0.01 ||
      Math.abs(
        d.employees.reduce((s, e) => s + employeeAmount(d, e), 0) - n(d.amount),
      ) > 0.05,
  );
  return {
    production,
    productionPercent,
    total,
    gross,
    vat,
    vatAmount,
    rows,
    difference,
    service: round(rows.reduce((s, r) => s + r.calculatedAmount, 0)),
    departmentErrors,
    valid:
      departments.length > 0 &&
      total > 0 &&
      !departmentErrors.length &&
      Math.abs(difference) < 1 &&
      rows.every((r) => r.base >= 0),
  };
}
